import { configureStore } from '@reduxjs/toolkit';
import { HomieLiteRentReducer } from './slice';
import { homeMeetings, homes, users } from './ducks';

export default configureStore({
  reducer: {
    homeMeetings,
    homes,
    users,
    homieLiteRents: HomieLiteRentReducer
  }
});
